import type { DailySummary, TimelineSegment, TimelineVisit } from '../domain/models';

function escapeCsv(value: unknown): string {
  const text = value === undefined || value === null ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function rowsToCsv(headers: string[], rows: unknown[][]): string {
  return [headers, ...rows].map((row) => row.map(escapeCsv).join(',')).join('\n');
}

export function visitsToCsv(visits: TimelineVisit[]): string {
  return rowsToCsv(
    ['id', 'startTime', 'endTime', 'lat', 'lng', 'radiusMeters', 'durationMinutes', 'placeName', 'confidence', 'source'],
    visits.map((visit) => [
      visit.id,
      visit.startTime,
      visit.endTime,
      visit.center.lat,
      visit.center.lng,
      Math.round(visit.radiusMeters),
      Math.round(visit.durationMinutes),
      visit.placeName ?? '',
      visit.confidence.toFixed(2),
      visit.source,
    ]),
  );
}

export function segmentsToCsv(segments: TimelineSegment[]): string {
  return rowsToCsv(
    ['id', 'startTime', 'endTime', 'startLat', 'startLng', 'endLat', 'endLng', 'distanceMeters', 'durationMinutes', 'mode', 'confidence', 'source'],
    segments.map((segment) => [
      segment.id,
      segment.startTime,
      segment.endTime,
      segment.start.lat,
      segment.start.lng,
      segment.end.lat,
      segment.end.lng,
      Math.round(segment.distanceMeters),
      Math.round(segment.durationMinutes),
      segment.inferredMode ?? 'unknown',
      segment.confidence.toFixed(2),
      segment.source,
    ]),
  );
}

export function dailySummariesToCsv(summaries: DailySummary[]): string {
  return rowsToCsv(
    ['date', 'distanceMeters', 'activeMinutes', 'stayMinutes', 'visitCount', 'tags', 'confidence'],
    summaries.map((summary) => [
      summary.date,
      Math.round(summary.distanceMeters),
      Math.round(summary.activeMinutes),
      Math.round(summary.stayMinutes),
      summary.visitCount,
      summary.tags.join('|'),
      summary.confidence.toFixed(2),
    ]),
  );
}
